import { gql } from '@apollo/client'

export const ADD_TEST_MUTATION = gql`
  mutation AddTest($inputData: TestInput!) {
    addTest(inputData: $inputData) {
      id
    }
  }
`
